import type { RefObject } from "react";
import { useEffect } from "react";
import type { FieldValues, Path, UseFormReturn } from "react-hook-form";

function useAutofocusFormField<
  TFieldValues extends FieldValues = FieldValues,
  TContext = unknown,
  TTransformedValues = TFieldValues,
>(form: UseFormReturn<TFieldValues, TContext, TTransformedValues>, name: Path<TFieldValues>) {
  useEffect(() => {
    setTimeout(() => {
      form.setFocus(name);
    }, 0);
  }, [form, name]);
}

type Handle<
  TFieldValues extends FieldValues = FieldValues,
  TContext = unknown,
  TTransformedValues = TFieldValues,
> = {
  hookForm: UseFormReturn<TFieldValues, TContext, TTransformedValues>;
} | null;

function useAutofocusFormField2<
  TFieldValues extends FieldValues = FieldValues,
  TContext = unknown,
  TTransformedValues = TFieldValues,
>(
  formRef: RefObject<Handle<TFieldValues, TContext, TTransformedValues>>,
  name: Path<TFieldValues>,
  noData: boolean,
) {
  useEffect(() => {
    if (noData) return;

    setTimeout(() => {
      formRef.current?.hookForm.setFocus(name);
    }, 0);
  }, [formRef, name, noData]);
}

export { useAutofocusFormField, useAutofocusFormField2 };
